import {inject, injectable} from "inversify";
import type {IUser} from "data/stores/user/user.store";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {ISSOPayload} from "data/utils/SSO";

export type IUserLoginPayload = ISSOPayload & {displayName?: string};

export interface ILoginPayload {
	email: string;
	password: string;
}

export interface IUserExistsResponse {
	terms: boolean;
	displayName: string | null;
	isNewUser: boolean;
}

type TLoginResponse = IApiResponse<{user: IUser}>;
type TUserExistsResponse = IApiResponse<IUserExistsResponse>;

export interface IAuthApiProvider {
	login: (params: IUserLoginPayload) => Promise<AxiosResponse<TLoginResponse>>;
	logout: () => Promise<AxiosResponse>;
	backdoor: (formData: FormData) => Promise<AxiosResponse<TLoginResponse>>;
	getIsUserExists: (uuid: string) => Promise<AxiosResponse<TUserExistsResponse>>;
}

@injectable()
export class AuthApiProvider implements IAuthApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	login = (params: IUserLoginPayload) => this._http.post<TLoginResponse>("auth/login", params);

	logout = () => this._http.post("auth/logout");

	backdoor = (formData: FormData) => this._http.post<TLoginResponse>(`auth/backdoor`, formData);

	getIsUserExists = (uuid: string) => this._http.get<TUserExistsResponse>(`user/check/${uuid}`);
}
